import { Flex } from '@styles';
import { bool, number } from 'prop-types';
import React from 'react';

import { barLayoutByProps } from './ProgressBar.layoutProps';

const ProgressItem = ({
  isCorrect,
  isPassed,
  numberOfItems,
  withCorrection,
}) => {
  const { backgroundColor } = barLayoutByProps({
    isCorrect,
    isPassed,
    withCorrection,
  });

  return (
    <Flex
      backgroundColor={backgroundColor}
      flex={1 / numberOfItems}
      height="100%"
    />
  );
};

ProgressItem.propTypes = {
  isCorrect: bool,
  isPassed: bool,
  numberOfItems: number.isRequired,
  withCorrection: bool,
};

ProgressItem.defaultProps = {
  isCorrect: false,
  isPassed: false,
  withCorrection: false,
};

export default ProgressItem;
